export const WELCOME_PAGE_STATES = {
  INTRO: 'intro',
  LOG_IN: 'log_in',
  FORGOT_PASSWORD: 'forgot_password',
  FORGOT_PASSWORD_SUCCESS: 'forgot_password_success',
  VERIFY_EMAIL: 'verify_email'
};
